/* Flat data-driven routes — Feb 2026
 * Routes are imported from grouped config files (routes/*.js) as plain arrays
 * and rendered via .map() to keep the JSX AST shallow. The previous deeply-
 * nested JSX (~150 sibling <Route> blocks, each 4 levels deep) was triggering
 * Babel's 'Maximum call stack size exceeded' on the dev build.
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import VerifyDocument from './pages/VerifyDocument';
import Layout from './components/Layout';
import coreRoutes from './routes/coreRoutes';
import procurementRoutes from './routes/procurementRoutes';
import salesRoutes from './routes/salesRoutes';
import accountingRoutes from './routes/accountingRoutes';
import operationsRoutes from './routes/operationsRoutes';
import adminRoutes from './routes/adminRoutes';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

// Iter-108: Root route — auth-aware. Visitors see Landing,
// authenticated users go straight to the Dashboard.
const RootRoute = ({ user }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Landing />;
  return (
    <Layout user={user}>
      <Dashboard user={user} />
    </Layout>
  );
};

const ALL_ROUTES = [
  ...coreRoutes,
  ...procurementRoutes,
  ...salesRoutes,
  ...accountingRoutes,
  ...operationsRoutes,
  ...adminRoutes,
];

function renderProtected({ path, Component, withUser }, user) {
  const inner = withUser ? <Component user={user} /> : <Component />;
  return (
    <Route
      key={path}
      path={path}
      element={
        <PrivateRoute>
          <Layout user={user}>{inner}</Layout>
        </PrivateRoute>
      }
    />
  );
}

export default function AppRoutes({ user, setUser }) {
  return (
    <Routes>
      <Route path="/login" element={<Login setUser={setUser} />} />
      <Route path="/landing" element={<Landing />} />
      {/* Patch 22.3 — public PDF Fingerprint Verification page */}
      <Route path="/verify-document" element={<VerifyDocument />} />
      <Route path="/" element={<RootRoute user={user} />} />
      {ALL_ROUTES.map((r) => renderProtected(r, user))}
    </Routes>
  );
}
